<template>
  <div class="guest-form">
    <!-- <input type="text" v-model="bdVal" > -->
    <span class="guest-form_email-notificaton">Чтобы получать оповещения по бронированию укажите Email</span>

    <div class="guest-form_container">
      <div class="guest-form_body flex-grid">
        <div class="flex-grid_row guest-form_fieldset-row">
          <div class="guest-form_fieldset-col flex-grid_col guest-form_fieldset-col flex-grid_col--40pct">
            <ui-field :label="'Фамилия'">
              <v-text-field
                solo
                class="ui-input"
                label="Введите фамилию"
                v-model="secondName"
                @change="updateSecondName"
                :rules="[validationRules.required]"
                required
              >
                <template v-slot:prepend-inner>
                  <v-icon>$user</v-icon>
                </template>
              </v-text-field>
            </ui-field>
          </div>

          <div class="guest-form_fieldset-col flex-grid_col guest-form_fieldset-col flex-grid_col--30pct">
            <ui-field :label="'Имя'">
              <v-text-field
                solo
                class="ui-input"
                label="Введите имя"
                v-model="firstName"
                @change="updateFirstName"
                :rules="[validationRules.required]"
                required
              >
                <template v-slot:prepend-inner>
                  <v-icon>$user</v-icon>
                </template>
              </v-text-field>
            </ui-field>
          </div>

          <div class="guest-form_fieldset-col flex-grid_col guest-form_fieldset-col flex-grid_col--30pct">
            <ui-field :label="'Отчество'">
              <template v-slot:headerAppend>
                <a
                  href="javascript:void(0)"
                  class="guest-form_no-third-name-link"
                  @click="onClickNoThirdName($event)"
                >Без отчества</a>
              </template>

              <v-text-field
                solo
                class="ui-input"
                label="Введите отчество"
                v-model="thirdName"
                @change="updateThirdName"
                :rules="isNoThirdName ? [] : [validationRules.required]"
                :required="isNoThirdName ? false : true"
                :disabled="isNoThirdName ? true : false"
              >
                <template v-slot:prepend-inner>
                  <v-icon>$user</v-icon>
                </template>
              </v-text-field>
            </ui-field>
          </div>
        </div>

        <div class="guest-form_fieldset-row flex-grid_row">
          <div class="guest-form_fieldset-col flex-grid_col guest-form_fieldset-col flex-grid_col--40pct">
            <ui-field :label="'Тип гостя'">
              <v-select
                class="ui-select"
                label="Выберите тип гостя"
                solo
                single-line
                :menu-props="{ offsetY: true }"
                :items="guestTypes"
                :rules="[validationRules.required]"
                v-model="guestType"
              >
                <template v-slot:prepend-inner>
                  <v-icon>$user</v-icon>
                </template>
              </v-select>
            </ui-field>
          </div>

          <div class="guest-form_fieldset-col flex-grid_col guest-form_fieldset-col flex-grid_col--30pct">
            <ui-field :label="'Дата рождения'">
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                nudge-top="-46px"
                v-model="birthdayMenu"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Дата рождения"
                    v-on="on"
                    solo
                    class="ui-input"
                    :rules="[validationRules.required, birthdayRules()]"
                    v-mask="'##.##.####'"
                    v-model="birthday"
                    ref="birthdayField"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>$calendar</v-icon>
                    </template>
                  </v-text-field>
                </template>

                <v-date-picker
                  locale="ru-ru"
                  width="auto"
                  class="ui-datepicker"
                  no-title
                  :min="minBirthdayPickerDate"
                  :max="maxBirthdayPickerDate"
                  v-model="birthdayPickerValue"
                  @change="onChangeBirthdayDatepicker"
                  first-day-of-week="1"
                  :weekday-format="helpers.getWeekDay"
                />
              </v-menu>
            </ui-field>
          </div>

          <div class="guest-form_fieldset-col flex-grid_col guest-form_fieldset-col flex-grid_col--30pct">
            <ui-field :label="'Пол'">
              <v-select
                class="ui-select"
                label="Выберите пол"
                solo
                single-line
                :menu-props="{ offsetY: true }"
                :items="[
                  {text: 'Мужской', value: 'male'},
                  {text: 'Женский', value: 'female'},
                ]"
                :rules="[validationRules.required]"
                v-model="gender"
                @change="updateGender"
              >
                <template v-slot:prepend-inner>
                  <v-icon>$gender</v-icon>
                </template>
              </v-select>
            </ui-field>
          </div>
        </div>

        <div
          class="guest-form_fieldset-row flex-grid_row"
          v-if="guestType === '0'"
        >
          <div class="guest-form_fieldset-col flex-grid_col guest-form_fieldset-col flex-grid_col--40pct">
            <ui-field :label="'Email'">
              <v-text-field
                solo
                class="ui-input"
                label="Введите email"
                :rules="[validationRules.required, validationRules.email, existEmailRules()]"
                v-model="email"
                @change="updateEmail"
                ref="emailField"
              >
                <template v-slot:prepend-inner>
                  <v-icon>$mailSolid</v-icon>
                </template>
              </v-text-field>
            </ui-field>
          </div>

          <div class="guest-form_fieldset-col flex-grid_col guest-form_fieldset-col flex-grid_col--30pct">
            <ui-field :label="'Телефон'">
              <v-text-field
                solo
                class="ui-input"
                label="Введите номер телефона"
                :rules="[validationRules.required, validationRules.tel, existPhoneRules()]"
                v-mask="'+7 (###) ###-##-##'"
                v-model="phone"
                @change="updatePhone"
                ref="phoneField"
              >
                <template v-slot:prepend-inner>
                  <v-icon>$phone</v-icon>
                </template>
              </v-text-field>
            </ui-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers/Helpers'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { IMaskDirective } from 'vue-imask'
import useFieldPool from "@/composables/fieldPool";

const {
  bindFieldPool,
  invokeFieldChange,
} = useFieldPool();

export default {
  name: 'guest-form',

  directives: {
    imask: IMaskDirective
  },

  props: {
    id: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    }
  },

  data: () => ({
    firstName: null,
    secondName: null,
    thirdName: null,
    isNoThirdName: null,
    guestType: null,
    birthday: null,
    gender: null,
    email: null,
    phone: null,

    validationRules: {
      required: value => !!value || 'Обязательно к заполнению.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Неверный формат email.'
      },
      tel: value => {
        // const pattern = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/
        const pattern = /^\+7\s{1}\(\d{3}\)\s{1}\d{3}\-\d{2}\-\d{2}$/
        return pattern.test(value) || 'Неверный формат номера телефона.'
      },

    },

    birthdayPickerValue: ``,
    birthdayMenu: false,
    existEmailRules: function () {
      return (value) => {
        const storedEmails = this.getGuestsList.filter(guest => guest.id !== this.id)
            .map(guest => guest.email) ?? [],
          includeEmailCount = storedEmails.filter(email => email === value).length;

        return !includeEmailCount || 'Уже указан гость с таким email.';
      };
    },
    existPhoneRules: function () {
      return (value) => {
        const storedPhones = this.getGuestsList.filter(guest => guest.id !== this.id)
            .map(guest => guest.phone) ?? [],
          includePhoneCount = storedPhones.filter(phone => phone === value).length;

        return !includePhoneCount || 'Уже указан гость с таким номером телефона.';
      };
    },
    birthdayRules: function() {
      return (value) => this.validateBirthday(value)
    },
  }),

  computed: {
    ...mapGetters({
      getGuestsList: 'guestsModule/getGuestsList',
      getGuestFields: 'guestsModule/getGuestFields',
      getField: 'guestsModule/getGuestField',
      getGuestTypes: 'dictionaries/getGuestTypes',
      getDateIn: 'selection/getDateIn',
      // getGenders: 'dictionaries/getGenders'
    }),

    helpers() {
      return Helpers
    },

    isCompleted() {
      return this.getField(this.id, 'isPersonalCompleted')
    },

    guestTypes() {
      let arr = this.getGuestTypes.slice(0)
      if(this.index === 0) {
        arr = arr.filter(i => i.value === '0' )
      }

      return arr
    },

    /**
     * @depracated
     */
    isPurchaser: {
      get() {
        return this.getField(this.id, 'isPurchaser')
      },
      set(value) {
        this.setPurchaser({id: this.id, value: value})
      }
    },

    // birthdayPickerValue: {
    //   get() {
    //     if(!this.birthday) return ``
    //     let a = this.birthday.split('.')
    //     return `${a[2]}-${a[1]}-${a[0]}`
    //   },
    //   set(value) {
    //     let a = value.split('-')
    //     this.updateBirthday(`${a[2]}.${a[1]}.${a[0]}`)
    //   }
    // },

    minBirthdayPickerDate() {
      let value
      let dateIn = new Date(this.getDateIn)

      switch(this.guestType) {
        case '0':
          value = new Date(
            dateIn.getFullYear() - 110,
            dateIn.getMonth(),
            dateIn.getDate()
          ).toISOString()
          break

        case '1':
          value = new Date(
            dateIn.getFullYear() - 14,
            dateIn.getMonth(),
            dateIn.getDate() + 2
          ).toISOString()
          break

        case '2':
          value = new Date(
            dateIn.getFullYear() - 4,
            dateIn.getMonth(),
            dateIn.getDate() + 2
          ).toISOString()
          break
      }

      return value
    },

    maxBirthdayPickerDate() {
      let value
      let dateIn = new Date(this.getDateIn)

      switch(this.guestType) {
        case '0':
          value = new Date(
            dateIn.getFullYear() - 14,
            dateIn.getMonth(),
            dateIn.getDate() + 1
          ).toISOString()
          break

        case '1':
          value = new Date(
            dateIn.getFullYear() - 4,
            dateIn.getMonth(),
            dateIn.getDate() + 1
          ).toISOString()
          break

        default:
          value = new Date(this.getDateIn).toISOString()
          break
      }

      return value
    },
  },

  methods: {
    ...mapMutations({
      setPurchaser: 'guestsModule/setPurchaser',
    }),

    ...mapActions({
      updateGuest: 'guestsModule/updateGuest',
      checkIsPersonalCompleted: 'guestsModule/checkIsPersonalCompleted',
      // storeCalcGuestPrice: 'guestsModule/calcGuestPrice',
    }),

    /**
     * Границы дат рождения по типам гостей относительно даты заезда.
     * Единый источник границ для birthdayRules, watch birthday и watch guestType.
     */
    birthdayBoundaries() {
      let dateIn = new Date(this.getDateIn)

      return {
        dateIn,
        min: new Date(dateIn.getFullYear() - 110, dateIn.getMonth(), dateIn.getDate()),
        baby: new Date(dateIn.getFullYear() - 4, dateIn.getMonth(), dateIn.getDate()),
        child: new Date(dateIn.getFullYear() - 14, dateIn.getMonth(), dateIn.getDate()),
      }
    },

    /**
     * Полная проверка даты рождения: формат + соответствие типу гостя.
     * Возвращает true или строку ошибки — та же логика, что раньше была в birthdayRules.
     */
    validateBirthday(value, guestType = this.guestType) {
      let splited = value ? value.split('.') : []
      let res = true

      // общие правила дня
      if(splited[0]
        && splited[0].length
        && (+splited[0] < 1 || +splited[0] > 31)
      ) {
        res = `Введено некорректное значение`
      }

      // общие правила месяца
      if(splited[1]
        && splited[1].length
        && (
          +splited[1] < 1
          || +splited[1] > 12
          || ( [1,3,5,7,8,10,12].findIndex(i => i === +splited[1]) !== -1 && +splited[0] > 31 )
          || ( [4,6,9,11].findIndex(i => i === +splited[1]) !== -1 && +splited[0] > 30 )
          || ( +splited[1] === 2 && +splited[0] > 29 )
        )
      ) {
        res = `Введено некорректное значение`
      }

      // правила диапазонов выбранного типа гостя
      if(
        splited[2]
        && splited[2].length < 4
      ) {
        res = `Введено некорректное значение`
      } else {
        let {dateIn, min, baby, child} = this.birthdayBoundaries()
        let bd = new Date(+splited[2], +splited[1] - 1, +splited[0])

        switch(String(guestType)) {
          case '0':
            if(bd > child || bd <= min) {
              res = 'Введенное значение не соответствует типу гостя'
            }
            break

          case '1':
            if(bd > baby || bd <= child) {
              res = 'Введенное значение не соответствует типу гостя'
            }
            break

          case '2':
            if(bd <= baby || bd > dateIn) {
              res = 'Введенное значение не соответствует типу гостя'
            }
            break

          default:
            break
        }
      }

      return res
    },

    /**
     * Синхронизация даты рождения со стором.
     * Пишем дату только если она введена полностью и валидна (формат + границы типа),
     * иначе в стор уходит null. Проверка выполняется явно, без $refs.birthdayField.valid:
     * пересчет правил Vuetify происходит асинхронно, и на момент срабатывания watch
     * valid может содержать результат предыдущего значения (гонка).
     */
    syncBirthdayToStore(value) {
      let storeBirthday = this.getField(this.id, `birthday`)
      let splited = value ? value.split('.') : []
      let newValue = null

      if(
        splited.length === 3
        && splited[2].length === 4
        && this.validateBirthday(value) === true
      ) {
        newValue = `${splited[2]}-${splited[1]}-${splited[0]}`
      }

      if(newValue !== storeBirthday) {
        this.updateGuestField('birthday', newValue)
      }
    },

    // onPhoneKeydown($event) {
    //   let oldVal = this.phone || '+7 ('
    //   setTimeout(() => {
    //     if(this.phone.length < 6 && $event.key === '8') {
    //       this.phone = oldVal
    //     }
    //     $event.preventDefault()
    //   }, 10)
    // },

    updateGuestField(fieldName, newValue) {
      this.updateGuest({
        id: this.id,
        obj: {
          [fieldName]: newValue,
        },
      })
    },

    updateFirstName(value) {
      this.updateGuestField('firstName', value)
      this.checkIsPersonalCompleted(this.id)
    },

    updateSecondName(value) {
      this.updateGuestField('secondName', value)
      this.checkIsPersonalCompleted(this.id)
    },

    updateThirdName(value) {
      this.updateGuestField('thirdName', value)
      this.checkIsPersonalCompleted(this.id)
    },

    updateGender(value) {
      this.updateGuestField('gender', value)
      this.checkIsPersonalCompleted(this.id)
    },

    updateEmail(value) {
      if(this.validationRules.email(value) === true) {
        this.updateGuestField('email', value)
      } else {
        this.updateGuestField('email', null)
      }
      this.checkIsPersonalCompleted(this.id)
      invokeFieldChange('email');
    },

    updatePhone(value) {
      // console.log('updatePhone')
      if(this.validationRules.tel(value) === true) {
        this.updateGuestField('phone', value)
      } else {
        this.updateGuestField('phone', null)
      }
      this.checkIsPersonalCompleted(this.id)
      invokeFieldChange('phone')
    },

    onClickNoThirdName(event) {
      let bool = this.isNoThirdName
      event.target.innerHTML = bool ? 'Без отчества' : 'С отчеством'

      this.isNoThirdName = !bool
      this.updateGuestField('isNoThirdName', !bool)
      this.checkIsPersonalCompleted(this.id)
    },

    onChangeBirthdayDatepicker(value) {
      let a = value.split(`-`)
      // this.updateBirthday(`${a[2]}.${a[1]}.${a[0]}`)
      this.birthday = `${a[2]}.${a[1]}.${a[0]}`
      this.birthdayMenu = false
    },
  },

  watch: {
    birthday(value) {
      // валидируем явно той же логикой, что в birthdayRules (см. syncBirthdayToStore),
      // не полагаясь на асинхронный пересчет правил Vuetify
      this.syncBirthdayToStore(value)
      this.checkIsPersonalCompleted(this.id)
    },

    guestType(value) {
      this.updateGuestField('guestType', value)
      if(value !== '0') {
        // this.isPurchaser = null
        // this.updateGuestField('isPurchaser', false)
      }

      this.$nextTick(() => {
        if(this.birthday) {
          // Введенная дата остается в поле: если она не соответствует новому типу,
          // правило подсветит ошибку (границы общие с birthdayRules, малыш — до 4 лет),
          // а в стор при невалидности уйдет null.
          this.syncBirthdayToStore(this.birthday)

          if(this.$refs.birthdayField) {
            // validate(true) — форсируем показ сообщений об ошибке правила
            this.$refs.birthdayField.validate(true)
          }
        }

        // после возможной перезаписи birthday в сторе пересчитываем завершенность
        this.checkIsPersonalCompleted(this.id)
      })
    },

    phone(v) {
      if(v.length < 6 && v[4] === '8') {
        this.$nextTick(() => this.phone = '+7 (')
      }
    }
  },

  created() {
    let storeGuest = this.getGuestFields(this.id, [
      'firstName',
      'secondName',
      'thirdName',
      'isNoThirdName',
      'guestType',
      'birthday',
      'gender',
      'email',
      'phone',
      // 'isPurchaser',
    ])

    this.firstName = storeGuest.firstName
    this.secondName = storeGuest.secondName
    this.thirdName = storeGuest.thirdName
    this.isNoThirdName = storeGuest.isNoThirdName
    this.guestType = storeGuest.guestType
    this.gender = storeGuest.gender
    this.email = storeGuest.email
    this.phone = storeGuest.phone

    if(storeGuest.birthday) {
      let bdArr = storeGuest.birthday.split('-')
      this.birthday = `${bdArr[2]}.${bdArr[1]}.${bdArr[0]}`
      this.birthdayPickerValue = storeGuest.birthday
    }
  },
  mounted() {
    bindFieldPool('email', this.$refs.emailField);
    bindFieldPool('phone', this.$refs.phoneField)
  },
}
</script>

<style lang="sass">
.guest-form
  padding: px-em(25) px-em(30) px-em(40)

.guest-form_email-notificaton
  display: block
  margin-bottom: px-em(25)

.guest-form_container
  width: 100%
  display: flex

.guest-form_body
  flex-grow: 1
  min-width: 1px

.guest-form_no-third-name-link
  margin-left: auto
  white-space: nowrap

.v-application .guest-form_no-third-name-link
  color: #316E80

@media screen and (max-width: $mobile-breakpoint)
  .guest-form
    padding: px-em(20,12) px-em(20,12) px-em(10,12)
  .guest-form_container
    flex-direction: column

    .v-input--selection-controls
      margin-top: 0
      padding-top: 0

    .v-input__slot
      margin-bottom: 0

    //.v-messages
    //  display: none

  .guest-form_fieldset-row
    flex-direction: column

  .guest-form_fieldset-col
    &.flex-grid_col
      width: 100%


</style>
